import { configureStore } from '@reduxjs/toolkit';

import { badgesSlice } from './reducers/badges-slice';
import { drawerContentSlice } from './reducers/drawer-content-slice';
import { gamesSlice } from './reducers/games-slice';
import { generalSlice } from './reducers/general-slice';
import { modalContentSlice } from './reducers/modal-content-slice';
import { operatorSlice } from './reducers/operator-slice';
import { tableSlice } from './reducers/table-slice';
import { uiSlice } from './reducers/ui-slice';
import { userSlice } from './reducers/user-slice';

const store = configureStore({
  reducer: {
    ui: uiSlice.reducer,
    general: generalSlice.reducer,
    badges: badgesSlice.reducer,
    drawerContent: drawerContentSlice.reducer,
    modalContent: modalContentSlice.reducer,
    games: gamesSlice.reducer,
    table: tableSlice.reducer,
    operator: operatorSlice.reducer,
    user: userSlice.reducer,
  },
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;

export default store;
